/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const config = {
  aws_project_region: 'us-east-1',
  aws_cognito_region: 'us-east-1',
  aws_cognito_identity_pool_id: 'us-east-1:42fae29a-e8d9-45bf-8394-096529bcaf24',
  aws_user_pools_id: 'us-east-1_mPiL828df',
  aws_user_pools_web_client_id: '4srda6sbkt1mgaj4grfdhd248d',
  oauth: {
    domain: 'abrightlab.auth.us-east-1.amazoncognito.com',
    scope: ['aws.cognito.signin.user.admin', 'email', 'openid', 'phone', 'profile'],
    redirectSignIn:
      'http://localhost:3000/home,https://www.customer-dev.abrightlab.com/home,https://www.customer-qa.abrightlab.com/home',
    redirectSignOut:
      'http://localhost:3000/,https://www.customer-dev.abrightlab.com/,https://www.customer-qa.abrightlab.com',
    responseType: 'token',
  },
  federationTarget: 'COGNITO_USER_POOLS',
  aws_cognito_username_attributes: ['EMAIL'],
  aws_cognito_social_providers: ['FACEBOOK', 'GOOGLE', 'APPLE'],
  aws_cognito_signup_attributes: ['NAME'],
  aws_cognito_mfa_configuration: 'OPTIONAL',
  aws_cognito_mfa_types: ['SMS', 'TOTP'],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 6,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ['EMAIL', 'PHONE_NUMBER'],
  aws_appsync_region: 'us-east-1',
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  aws_appsync_graphqlEndpoint: 'https://mucz6wyfm5cdneq3ulnrke2wiq.appsync-api.us-east-1.amazonaws.com/graphql',
  aws_appsync_apiKey: 'da2-5wh7e2yqondszcck5uymx6vwhy',
  aws_user_files_s3_bucket: 'arkstoragedev160717-dev',
  aws_user_files_s3_bucket_region: 'us-east-1',
  aws_cloud_logic_custom: [
    {
      name: 'getIdsApi',
      endpoint: 'https://api-dev.abrightlab.com/analytics/customerDashboard/submitQuery',
      region: 'us-east-1',
    },
    {
      name: 'getFacilities',
      endpoint: `https://api-dev.abrightlab.com/analytics/customerDashboard/getQueryResults`,
      region: 'us-east-1',
    },
    {
      name: 'taskSummary',
      endpoint: ` https://api-dev.abrightlab.com/analytics/dashboard/taskSummary`,
      region: 'us-east-1',
    },
    {
      name: 'taskPerformance',
      endpoint: ` https://api-dev.abrightlab.com/analytics/dashboard/task-performance`,
      region: 'us-east-1',
    },
    {
      name: 'inspectionByDays',
      endpoint: ` https://api-dev.abrightlab.com/analytics/dashboard/inspection-by-days`,
      region: 'us-east-1',
    },
    {
      name: 'inspectionByLocation',
      endpoint: ` https://api-dev.abrightlab.com/analytics/dashboard/inspection-by-locations`,
      region: 'us-east-1',
    },
    {
      name: 'taskInspection',
      endpoint: ` https://api-dev.abrightlab.com/analytics/dashboard/task-inspection`,
      region: 'us-east-1',
    },
    {
      name: 'paginatedTaskSummary',
      endpoint: `https://api-dev.abrightlab.com/analytics/dashboard/taskSummary/paginated`,
      region: 'us-east-1',
    },
    {
      name: 'noShowFacilities',
      endpoint: `https://api-dev.abrightlab.com/analytics/dashboard/noShowFacilities`,
      region: 'us-east-1',
    },
    {
      name: 'oneTimeJobs',
      endpoint: `https://api-dev.abrightlab.com/analytics/dashboard/oneTimeJobs`,
      region: 'us-east-1',
    },
    {
      name: 'Jobs',
      endpoint: `https://api-dev.abrightlab.com/analytics/dashboard/jobs/finder`,
      region: 'us-east-1',
    },
    {
      name: 'shiftTrend',
      endpoint: `https://api-dev.abrightlab.com/analytics/dashboard/shift-trend`,
      region: 'us-east-1',
    },
    {
      name: 'getFilterValues',
      endpoint: 'https://api-dev.abrightlab.com/jobfulfillment/work-orders/v3/filter-values',
      region: 'us-east-1',
    },
    {
      name: 'findAllWorkOrders',
      endpoint: `https://api-dev.abrightlab.com/jobfulfillment/work-orders/v3`,
      region: 'us-east-1',
    },
    {
      name: 'allSchedules',
      endpoint: 'https://api-dev.abrightlab.com/jobfulfillment/schedule-master/master/all-details/v2',
      region: 'us-east-1',
    },
    {
      name: 'vmsLogin',
      endpoint: `https://develop.d12l0xd7je4gng.amplifyapp.com/auth/login`,
    },
    {
      name: 'vmsHandoffMint',
      endpoint: `https://api-dev.abrightlab.com/usermanagement/user-handoff/mint-code`,
      region: 'us-east-1',
    },
    {
      name: 'generateGenericUserName',
      endpoint: 'https://api-dev.abrightlab.com/usermanagement/users/vendor',
      region: 'us-east-1',
    },
    {
      name: 'setUserPassword',
      endpoint: 'https://api-dev.abrightlab.com/usermanagement/cognito-user/password/user',
      region: 'us-east-1',
    },
    {
      name: 'getMasterServices',
      endpoint: 'https://api-dev.abrightlab.com/jobfulfillment/schedule-master',
      region: 'us-east-1',
    },
    {
      name: 'findAllWorkOrders',
      endpoint: `https://api-dev.abrightlab.com/jobfulfillment/work-orders/v3`,
      region: 'us-east-1',
    },
    {
      name: 'updateGeoFence',
      endpoint: `https://api-dev.abrightlab.com/customerprofile/facility/ops-v2/facilities`,
      region: 'us-east-1',
    },
    {
      name: 'updateFacilityCoordinates',
      endpoint: `https://api-dev.abrightlab.com/jobfulfillment/jobFacility/updateFacilityCoordinates`,
      region: 'us-east-1',
    },
    {
      name: 'syncFacilityCoordinates',
      endpoint: `https://api-dev.abrightlab.com/jobfulfillment/jobFacility/syncFacilityCoordinates`,
      region: 'us-east-1',
    },
    {
      name: 'manageScheduleAssignments',
      endpoint: `https://api-dev.abrightlab.com/jobfulfillment/schedule-assignments/manageScheduleAssignments`,
      region: 'us-east-1',
    },
    {
      name: 'addScheduleAssignments',
      endpoint: `https://api-dev.abrightlab.com/jobfulfillment/schedule-assignments`,
      region: 'us-east-1',
    },
    {
      name: 'createSchedule',
      endpoint: `https://api-dev.abrightlab.com/jobfulfillment/scheduleMaster/create`,
      region: 'us-east-1',
    },
    {
      name: 'allPunchInOutByWorkDay',
      endpoint: `https://api-dev.abrightlab.com/jobfulfillment/work-day/PunchCard/all`,
      region: 'us-east-1',
    },
    {
      name: 'schedulesByDate',
      endpoint: `https://api-dev.abrightlab.com/jobfulfillment/schedules/by-date/schedule`,
      region: 'us-east-1',
    },
    {
      name: 'schedulesByDateV2',
      endpoint: `https://api-dev.abrightlab.com/jobfulfillment/schedules/by-date/scheduleV2`,
      region: 'us-east-1',
    },
    {
      name: 'rescheduleWorkDays',
      endpoint: `https://api-dev.abrightlab.com/jobfulfillment/schedules/reschedule`,
      region: 'us-east-1',
    },
    {
      name: 'allUpcomingShifts',
      endpoint: `https://api-dev.abrightlab.com/jobfulfillment/schedules/future-shifts/vendor`,
      region: 'us-east-1',
    },
    {
      name: 'cancelSchedules',
      endpoint: `https://api-dev.abrightlab.com/jobfulfillment/schedules/cancel-schedules`,
      region: 'us-east-1',
    },
    {
      name: 'allVendorsOnARK',
      endpoint: `https://api-dev.abrightlab.com/vendorprofile/vendor/vendors-on-ark`,
      region: 'us-east-1',
    },
    {
      name: 'allVendorsOnARKPagination',
      endpoint: `https://api-dev.abrightlab.com/vendorprofile/vendor/vendors-on-ark/pagination`,
      region: 'us-east-1',
    },
    {
      name: 'createAdhocShifts',
      endpoint: `https://api-dev.abrightlab.com/jobfulfillment/unschedule-work/create`,
      region: 'us-east-1',
    },
    {
      name: 'createRetrospective',
      endpoint: `https://api-dev.abrightlab.com/jobfulfillment/unschedule-work/retrospective`,
      region: 'us-east-1',
    },
    {
      name: 'getWorkTickets',
      endpoint: `https://api-dev.abrightlab.com/jobs/workTicket/all`,
      region: 'us-east-1',
    },
    {
      name: 'getAllJobs',
      endpoint: `https://api-dev.abrightlab.com/jobs/all-jobs`,
      region: 'us-east-1',
    },
    {
      name: 'getAllBids',
      endpoint: `https://api-dev.abrightlab.com/jobs/job-bids/all-bids`,
      region: 'us-east-1',
    },
    {
      name: 'getAllWorkOrders',
      endpoint: `https://api-dev.abrightlab.com/jobfulfillment/v2/work-orders`,
      region: 'us-east-1',
    },
    {
      name: 'jobBidSummary',
      endpoint: `https://api-dev.abrightlab.com/jobs/job-bids/bid`,
      region: 'us-east-1',
    },
    {
      name: 'updateScheduleMaster',
      endpoint: `https://api-dev.abrightlab.com/jobfulfillment/schedule-master/update-many`,
      region: 'us-east-1',
    },
    {
      name: 'serviceCategory',
      endpoint: `https://api-dev.abrightlab.com/masterdata/v3/service-category`,
      region: 'us-east-1',
    },
    {
      name: 'getAllProcesses',
      endpoint: `https://api-dev.abrightlab.com/usermanagement/users/process`,
      region: 'us-east-1',
    },
    {
      name: 'getProcessEvents',
      endpoint: `https://api-dev.abrightlab.com/usermanagement/users/process/:processId/events/`,
      region: 'us-east-1',
    },
    {
      name: 'getAllTasks',
      endpoint: `https://api-dev.abrightlab.com/masterdata/service-management/task-management`,
      region: 'us-east-1',
    },
    {
      name: 'createTask',
      endpoint: `https://api-dev.abrightlab.com/masterdata/task-master/ops-v2`,
      region: 'us-east-1',
    },
    {
      name: 'serviceTaskMapping',
      endpoint: `https://api-dev.abrightlab.com/jobfulfillment/job-service-creation`,
      region: 'us-east-1',
    },
    {
      name: 'createService',
      endpoint: `https://api-dev.abrightlab.com/masterdata/v3/service-category/ops-v2/creator`,
      region: 'us-east-1',
    },
    {
      name: 'taskSubTaskMapping',
      endpoint: `https://api-dev.abrightlab.com/jobfulfillment/task-subtask-mapping`,
      region: 'us-east-1',
    },
    {
      name: 'getJobBids',
      endpoint: `https://api-dev.abrightlab.com/jobs/job-bids`,
      region: 'us-east-1',
    },
    {
      name: 'jobSummaryV2',
      endpoint: `https://api-dev.abrightlab.com/jobs/customers/:customerId/jobs/:jobId/summaryV2`,
      region: 'us-east-1',
    },
    {
      name: 'facilities',
      endpoint: `https://api-dev.abrightlab.com/customerprofile/facility/customer/:customerId`,
      region: 'us-east-1',
    },
    {
      name: 'findAllWithSearchQuery',
      endpoint: `https://api-dev.abrightlab.com/customerprofile/facility/ops-v2/customer/:customerId`,
      region: 'us-east-1',
    },
    {
      name: 'getTermsAndConditions',
      endpoint: `https://api-dev.abrightlab.com/jobs/job-bids/velociti-tc-pdf`,
      region: 'us-east-1',
    },
    {
      name: 'manageVendorAssignments',
      endpoint: `https://api-dev.abrightlab.com/jobfulfillment/job-vendor/manage-vendor-assignments`,
      region: 'us-east-1',
    },
    {
      name: 'createVMSJob',
      endpoint: `https://api-dev.abrightlab.com/jobs/create-vms-job`,
      region: 'us-east-1',
    },
    {
      name: 'pendingCustomerApprovalOneTimeJobs',
      endpoint: `https://api-dev.abrightlab.com/jobs/pendingCustomerApprovalOneTimeJobs`,
      region: 'us-east-1',
    },
    {
      name: 'acceptRejectBidProposal',
      endpoint: `https://api-dev.abrightlab.com/jobs/job-recommendations/transaction`,
      region: 'us-east-1',
    },
    {
      name: 'createVMSJob',
      endpoint: `https://api-dev.abrightlab.com/jobs/create-vms-job`,
      region: 'us-east-1',
    },
    {
      name: 'createServiceRequest',
      endpoint: `https://api-dev.abrightlab.com/servicerequests/service-requests/create`,
      region: 'us-east-1',
    },
    {
      name: 'jobManagers',
      endpoint: `https://api-dev.abrightlab.com/jobs/job-managers`,
      region: 'us-east-1',
    },
    {
      name: 'signedApproval',
      endpoint: `https://api-dev.abrightlab.com/jobfulfillment/service-channel/signed-approval`,
      region: 'us-east-1',
    },
    {
      name: 'bidProposalSummary',
      endpoint: `https://api-dev.abrightlab.com/jobs/job-bids/bid/:bidId/bid-proposal-summary`,
      region: 'us-east-1',
    },
    {
      name: 'fetchPOAttachments',
      endpoint: `https://api-dev.abrightlab.com/jobs/job-attachments/jobs/:jobId/attachments`,
      region: 'us-east-1',
    },
    {
      name: 'updateRouting',
      endpoint: `https://api-dev.abrightlab.com/jobfulfillment/schedule-master/routing/:woScheduleMasterId`,
      region: 'us-east-1',
    },
    {
      name: 'getJobsForDM',
      endpoint: `https://api-dev.abrightlab.com/jobs/organization/:organizationId`,
      region: 'us-east-1',
    },
    {
      name: 'getCustomerFacilities',
      endpoint: `https://api-dev.abrightlab.com/jobs/orgId/:orgId/user/:userId`,
      region: 'us-east-1',
    },
  ],
};

export default config;
